var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRequiredCjk = function SvgRequiredCjk(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 5.2a2.266 2.266 0 1 0 0-4.532 2.266 2.266 0 0 0 0 4.533",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.665 0 24 1.336 1.336 24 0 22.665z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.934 14.265a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 1.336 1.336 24 0 22.665 22.665 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.063 14.265a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533M12 23.332a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1.336 1.336 0 24 22.665 22.665 24z"
  })));
};
export { SvgRequiredCjk as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M12 5.2a2.266 2.266 0 1 0 0-4.532 2.266 2.266 0 0 0 0 4.533' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M22.665 0 24 1.336 1.336 24 0 22.665z'/%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M2.934 14.265a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M24 1.336 1.336 24 0 22.665 22.665 0z'/%3e%3cpath fill='currentColor' fill-rule='evenodd' d='M21.063 14.265a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533M12 23.332a2.266 2.266 0 1 0 0-4.533 2.266 2.266 0 0 0 0 4.533' clip-rule='evenodd'/%3e%3cpath fill='currentColor' d='M0 1.336 1.336 0 24 22.665 22.665 24z'/%3e%3c/svg%3e";